import { Type, type Static } from '@sinclair/typebox';
import { SocialAuthModeSchema } from '../../common/social-auth.schema';

export const SocialAuthStartBodySchema = Type.Object(
  {
    mode: SocialAuthModeSchema,
    redirect: Type.String({ minLength: 1, description: 'Dashboard path or URL to return to after social authentication.' }),
  },
  { additionalProperties: false, description: 'Parameters for starting social authentication from the Dashboard.' },
);
export type SocialAuthStartBody = Static<typeof SocialAuthStartBodySchema>;

export const UserAuthenticationBodySchema = Type.Object({
  email: Type.String(),
  password: Type.String(),
  turnstile_token: Type.String(),
});

export const UserRegisterBodySchema = Type.Object({
  email: Type.String({ format: 'email', minLength: 1, maxLength: 50 }),
  password: Type.String({ minLength: 12, maxLength: 128 }),
  name: Type.Optional(Type.String({ maxLength: 50 })),
  is_invite: Type.Boolean(),
  turnstile_token: Type.String({ minLength: 1, maxLength: 2048 }),
});

export const MfaVerifyBodySchema = Type.Object({
  code: Type.String({ maxLength: 6 }),
  token: Type.String(),
});

export const MfaValidateBodySchema = Type.Object({
  code: Type.String({ maxLength: 6, minLength: 6 }),
  secret: Type.String(),
});

export type UserAuthenticationBody = Static<typeof UserAuthenticationBodySchema>;
export type UserRegisterBody = Static<typeof UserRegisterBodySchema>;
export type MfaVerifyBody = Static<typeof MfaVerifyBodySchema>;
export type MfaValidateBody = Static<typeof MfaValidateBodySchema>;

export const UserReauthenticationBodySchema = Type.Object({
  password: Type.Optional(Type.String()),
  code: Type.Optional(Type.String()),
});
export type UserReauthenticationBody = Static<typeof UserReauthenticationBodySchema>;
